import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Footer from './Footer';

const Layout = ({ children, openModal }) => {
  // Mock notifications - in a real app, this would come from a context or state management
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      title: 'Server test completed',
      message: 'play.example.com was tested successfully',
      icon: 'fa-shield-alt',
      color: 'accent-pink',
      time: '2 minutes ago',
      read: false
    },
    {
      id: 2,
      title: 'Bot connection successful',
      message: '3 bots connected to target server',
      icon: 'fa-robot',
      color: 'accent-blue',
      time: '15 minutes ago',
      read: false
    },
    {
      id: 3,
      title: 'RCON password found',
      message: 'Successfully accessed mc.server.com via RCON',
      icon: 'fa-terminal',
      color: 'accent-green',
      time: '1 hour ago',
      read: true
    },
    {
      id: 4,
      title: 'New vulnerability detected',
      message: 'Security issue found in target server',
      icon: 'fa-exclamation-triangle',
      color: 'accent-orange',
      time: '3 hours ago',
      read: true
    },
    {
      id: 5,
      title: 'Account matched',
      message: 'Found matching credentials for Player123',
      icon: 'fa-user-check',
      color: 'accent-purple',
      time: '5 hours ago',
      read: true
    },
    {
      id: 6,
      title: 'Subscription renewed',
      message: 'Your Premium plan has been renewed',
      icon: 'fa-crown',
      color: 'accent-yellow',
      time: '1 day ago',
      read: true
    }
  ]);

  return (
     <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex-1 overflow-y-auto">
        {/* Pass openModal to Topbar */}
        <Topbar notifications={notifications} openModal={openModal} />
        {/* Make children container take remaining height and allow scrolling */}
        <main className="flex-1 overflow-y-auto">
            {children}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;